import React, { Suspense } from 'react';
import { ThemeProvider } from '@mui/material';
import { observer } from 'mobx-react';
import { getEnv } from '@jbrowse/core/util';
import { readConfObject } from '@jbrowse/core/configuration';
import { createJBrowseTheme } from '@jbrowse/core/ui';
import { EmbeddedViewContainer, ModalWidget } from '@jbrowse/embedded-core';
const JBrowseCircularGenomeView = observer(function ({ viewState, }) {
    const { session } = viewState;
    const { view } = session;
    const { pluginManager } = getEnv(session);
    const viewType = pluginManager.getViewType(view.type);
    if (!viewType) {
        throw new Error(`unknown view type ${view.type}`);
    }
    const { ReactComponent } = viewType;
    const theme = createJBrowseTheme(readConfObject(viewState.config.configuration, 'theme'));
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(EmbeddedViewContainer, { key: `view-${view.id}`, view: view },
            React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
                React.createElement(ReactComponent, { model: view, session: session }))),
        React.createElement(ModalWidget, { session: session })));
});
export default JBrowseCircularGenomeView;
